import { AlertTriangle } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import type { LegalRepresentativeData } from "@/types/impact-analysis";

type LegalRepresentativeFormProps = {
  data: LegalRepresentativeData;
  onDataChange: (field: keyof LegalRepresentativeData, value: string) => void;
  fieldErrors: Record<string, string>;
};

export function LegalRepresentativeForm({
  data,
  onDataChange,
  fieldErrors,
}: LegalRepresentativeFormProps) {
  function FieldError({ fieldName }: { fieldName: string }) {
    const error = fieldErrors[fieldName];
    if (!error) return null;

    return (
      <div className="flex items-center gap-2 mt-1">
        <AlertTriangle className="h-4 w-4 text-destructive" />
        <span className="text-sm text-destructive">{error}</span>
      </div>
    );
  }
  return (
    <Card className="border-primary/20 mt-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base md:text-lg">
          Reprezentant entitate
        </CardTitle>
        <CardDescription className="text-xs md:text-sm">
          Completați datele reprezentantului entității
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 md:grid-cols-2 pt-0 pb-6 md:pt-0 md:pb-6">
        <div>
          <Label className="text-xs md:text-sm" htmlFor="repr-prenume">
            Prenume <span className="text-destructive ml-1">*</span>
          </Label>
          <Input
            id="repr-prenume"
            value={data.prenume}
            onChange={(e) => onDataChange("prenume", e.target.value)}
            placeholder="Prenumele"
            className={cn(
              fieldErrors["repr-prenume"] ? "border-destructive" : "",
              "text-xs md:text-sm"
            )}
          />
          <FieldError fieldName="repr-prenume" />
        </div>
        <div>
          <Label className="text-xs md:text-sm" htmlFor="repr-nume">
            Nume <span className="text-destructive ml-1">*</span>
          </Label>
          <Input
            id="repr-nume"
            value={data.nume}
            onChange={(e) => onDataChange("nume", e.target.value)}
            placeholder="Numele"
            className={cn(
              fieldErrors["repr-nume"] ? "border-destructive" : "",
              "text-xs md:text-sm"
            )}
          />
          <FieldError fieldName="repr-nume" />
        </div>
        <div>
          <Label className="text-xs md:text-sm" htmlFor="repr-functia">
            Funcția <span className="text-destructive ml-1">*</span>
          </Label>
          <Input
            id="repr-functia"
            value={data.functia}
            onChange={(e) => onDataChange("functia", e.target.value)}
            placeholder="Funcția"
            className={cn(
              fieldErrors["repr-functia"] ? "border-destructive" : "",
              "text-xs md:text-sm"
            )}
          />
          <FieldError fieldName="repr-functia" />
        </div>
      </CardContent>
    </Card>
  );
}
